import React from 'react';
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import user_login, { setUserLoginData } from "../reduxContainer/StateActions";
import "../styles/loginpage.css";
import G from "../images/google.png";
import { auth, provider, usersRef } from '../firebase';
import { getUsersCollectionIds } from '../App';

const LoginPage = () => {
    const dispatch = useDispatch();

    const signIn = async () => {
        const signedIn_email_ids = await getUsersCollectionIds();
        try {
            const result = await auth.signInWithPopup(provider);
            const userData = {
                accessToken: result.user.multiFactor.user.accessToken,
                displayName: result.user.displayName,
                email: result.user.email,
                emailVerified: result.user.emailVerified,
                photoURL: result.user.photoURL,
                uid: result.user.uid,
            };
            localStorage.setItem("InfyMailBoxAppToken", JSON.stringify(userData));
            if (!signedIn_email_ids.includes(userData.email)) {
                await usersRef.doc(userData.email).set({
                    profileImageFilename: userData.displayName,
                    email: userData.email,
                    profileImage_path: userData.photoURL,
                    displayName: userData.displayName
                });
            }
            dispatch(setUserLoginData(userData));
            dispatch(user_login(true));
        } catch (error) {
            alert(error.message);
        }
    };

    return (
        <>
            <div className="container">
                <div className="top"></div>
                <div className="bottom"></div>
                <div className="center">
                    <h2>
                        <span style={{ color: "#fc8803" }}>Welcome </span>
                        <span style={{ color: "#0356fc" }}>to Infy</span>
                        <span style={{ color: "green" }}> Verse</span>
                    </h2>
                    <div className='google_box'>
                        <img src={G} alt="Google" width="50px" />
                        <Link to="/task-board" onClick={signIn} className='loginwithgoogle'>Continue with Google</Link>
                    </div>
                    <h2>&nbsp;</h2>
                </div>
            </div>
        </>
    )
}

export default LoginPage